import { BiSearchAlt } from "react-icons/bi";
import { FaChartLine } from "react-icons/fa";
import { MdOutlineSettingsInputComponent } from "react-icons/md";

export const successSteps = [
  {
    icon: <BiSearchAlt size={36} />,
    title: "1. Analyse",
    text: "Zuerst schauen wir uns gemeinsam deine Ziele an. Wir wollen verstehen, was du mit deiner Website erreichen willst und wie wir dir dabei helfen können. Dazu analysieren wir deine Zielgruppe und schauen uns auch deine Konkurrenz an, um einen Überblick über deine aktuelle Situation zu bekommen.",
  },
  {
    icon: <MdOutlineSettingsInputComponent size={32} />,
    title: "2. Optimierung",
    text: "Mit unserer langjährigen Erfahrung erkennen wir die Potenziale deines Unternehmens. Wir entwickeln eine Webseite, die zu Deinen Zielen passt und Dich auf die nächste Stufe bringt - in Kiel und darüber hinaus.",
  },
  {
    icon: <FaChartLine size={32} />,
    title: "3. Umsetzung",
    text: "Auch nachdem deine Website online ist, stehen wir dir als Webdesign-Agentur zur Seite. Bei Fragen, Problemen oder Anregungen sind wir für dich da und helfen dir bestmöglich weiter. Unsere Experten decken viele Bereiche ab, sodass du für jedes Anliegen den richtigen Ansprechpartner hast.",
  },
];
